export { };

declare global {
    interface String {
        toNumber(): number;
    }
}

String.prototype.toNumber = function (this: string) { return parseFloat(this) };